import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CircularSpinner from '@shared/atoms/CircularSpinner';
import Table, { ORDER_TYPES } from '@shared/organisms/Table';
import T from '@shared/atoms/Typography';

const MembershipsTab = ({ loading, memberships }) => {
  const { t } = useTranslation();

  return (
    <>
      {loading && <CircularSpinner static />}
      {memberships?.length > 0 && !loading && (
        <Table
          ariaLabel="Memberships table"
          columns={[
            {
              key: 'organizationName',
              label: t('backoffice.users.organization'),
            },
            {
              key: 'role',
              label: t('backoffice.users.role'),
            },
          ]}
          items={memberships.map(({ organization, role }) => ({
            id: organization.name,
            organizationName: organization.name,
            role,
          }))}
          defaultOrder={ORDER_TYPES.ASC}
          defaultOrderBy="organizationName"
        />
      )}
      {memberships?.length === 0 && !loading && (
        <T>{t('backoffice.users.noMembershipsFound')}</T>
      )}
    </>
  );
};

MembershipsTab.propTypes = {
  loading: PropTypes.bool.isRequired,
  memberships: PropTypes.array,
};

export default MembershipsTab;
